import { getTimeSpan, dispatchData } from '../index';

const getTimespanForString = input => {
  const [hours, minutes] = input.split(':').map(Number);

  const totalMilliseconds = hours * 60 * 60 * 1000 + minutes * 60 * 1000;
  let timespan = getTimeSpan(totalMilliseconds);
  return timespan;
};

const updateItsDescriptiveProtocol = (dispatch, data, task, updatedDescriptiveProtocol) => {
  const tasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  tasks.splice(taskIndex, 1, {
    ...task,
    itsDescriptiveProtocol: updatedDescriptiveProtocol,
  });

  dispatchData(dispatch, data, tasks);
};

const handleStartChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  let timespan = getTimespanForString(event.target.value);
  updatedItsDescriptiveProtocol.start = timespan;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const handleEndChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  let timespan = getTimespanForString(event.target.value);

  updatedItsDescriptiveProtocol.end = timespan;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const handleTroubleDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  updatedItsDescriptiveProtocol.troubleDescription = event.target.value;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const handlePerformedActivitiesDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  updatedItsDescriptiveProtocol.performedActivitiesDescription = event.target.value;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const handleDamageDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  updatedItsDescriptiveProtocol.damageDescription = event.target.value;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const handleClientNotAgreedDescriptionChange = (event, dispatch, task, data) => {
  const updatedItsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  updatedItsDescriptiveProtocol.clientNotAgreedDescription = event.target.value;

  updateItsDescriptiveProtocol(dispatch, data, task, updatedItsDescriptiveProtocol);
};

const toggleProtocolFields = (dispatch, data, task, itsDescriptiveProtocol) => {
  const updatedDescriptiveProtocol = { ...itsDescriptiveProtocol };
  updatedDescriptiveProtocol.open = !updatedDescriptiveProtocol.open;

  const updatedTask = {
    ...task,
    itsDescriptiveProtocol: updatedDescriptiveProtocol,
  };

  const updatedTasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const toggleDamageDescriptionField = (dispatch, task, data, showField) => {
  let itsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  let updatedDamageDescriptionField = itsDescriptiveProtocol.damageDescriptionField;
  let updatedDamageDescription = itsDescriptiveProtocol.damageDescription;

  if (updatedDamageDescriptionField && updatedDamageDescriptionField === 'no' && showField) {
    updatedDamageDescriptionField = 'yes';
  } else if (
    updatedDamageDescriptionField &&
    updatedDamageDescriptionField === 'yes' &&
    !showField
  ) {
    updatedDamageDescriptionField = 'no';
    updatedDamageDescription = '';
  } else {
    return;
  }

  const updatedTask = {
    ...task,
    itsDescriptiveProtocol: {
      ...task.itsDescriptiveProtocol,
      damageDescriptionField: updatedDamageDescriptionField,
      damageDescription: updatedDamageDescription,
    },
  };

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const updatedTasks = [...data.tasks];
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const toggleAggreedWithPerformedActivitiesDescriptionField = (dispatch, task, data, showField) => {
  let itsDescriptiveProtocol = { ...task.itsDescriptiveProtocol };
  let updatedAgreeWithPerformedActivitiesField =
    itsDescriptiveProtocol.agreeWithPerformedActivitiesField;
  let updatedClientNotAgreedDescription = itsDescriptiveProtocol.clientNotAgreedDescription;
  if (
    updatedAgreeWithPerformedActivitiesField &&
    updatedAgreeWithPerformedActivitiesField === 'no' &&
    showField
  ) {
    updatedAgreeWithPerformedActivitiesField = 'yes';
  } else if (
    updatedAgreeWithPerformedActivitiesField &&
    updatedAgreeWithPerformedActivitiesField === 'yes' &&
    !showField
  ) {
    updatedAgreeWithPerformedActivitiesField = 'no';
    updatedClientNotAgreedDescription = '';
  } else {
    return;
  }

  const updatedTask = {
    ...task,
    itsDescriptiveProtocol: {
      ...task.itsDescriptiveProtocol,
      agreeWithPerformedActivitiesField: updatedAgreeWithPerformedActivitiesField,
      clientNotAgreedDescription: updatedClientNotAgreedDescription,
    },
  };

  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  const updatedTasks = [...data.tasks];
  updatedTasks.splice(taskIndex, 1, updatedTask);

  dispatchData(dispatch, data, updatedTasks);
};

const validateDescriptiveProtocol = itsDescriptiveProtocol => {
  let messages = [];
  if (itsDescriptiveProtocol.damageDescriptionField === 'yes') {
    const errorTextForLessLenght =
      'Моля, опишете с повече от 3 символа нанесените щети при посещението в констативния протокол!';
    const errorTextForMoreLength =
      'Описанието за нанесена щета в констативния протокол за посещение не може да бъде над 2000 символа';
    messages.push(
      getMessageForField(
        itsDescriptiveProtocol.damageDescription,
        errorTextForLessLenght,
        errorTextForMoreLength
      )
    );
  }

  if (itsDescriptiveProtocol.agreeWithPerformedActivitiesField === 'no') {
    const errorTextForLessLenght =
      'Моля, опишете с повече от 3 символа забележките по извършените дейности в констативния протокол за посещение!';
    const errorTextForMoreLength =
      'Забележката по извършените дейности в констативния протокол за посещение не може да бъде над 2000 символа!';
    messages.push(
      getMessageForField(
        itsDescriptiveProtocol.clientNotAgreedDescription,
        errorTextForLessLenght,
        errorTextForMoreLength
      )
    );
  }

  const errorForTroubleDescriptionLessLenght =
    'Описание на повредата в констативния протокол за посещение трябва да е повече от 3 символа!';
  const errorForTroubleDescriptionMoreLength =
    'Oписание на повредата в констативния протокол за посещение не може да бъде над 2000 символа';
  messages.push(
    getMessageForField(
      itsDescriptiveProtocol.troubleDescription,
      errorForTroubleDescriptionLessLenght,
      errorForTroubleDescriptionMoreLength
    )
  );

  const errorForPerformedActivitiesLessLenght =
    'Описание на извършените дейности в констативния протокол за посещение трябва да е повече от 3 символа!';
  const errorForPerformedActivitiesMoreLength =
    'Oписание на извършените дейности в констативния протокол за посещение не може да бъде над 2000 символа';
  messages.push(
    getMessageForField(
      itsDescriptiveProtocol.performedActivitiesDescription,
      errorForPerformedActivitiesLessLenght,
      errorForPerformedActivitiesMoreLength
    )
  );

  return messages;
};

const getMessageForField = (field, errorTextForLessLenght, errorTextForMoreLength) => {
  if (!field || field.length < 3) return errorTextForLessLenght;
  else if (!field && field.length > 2000) return errorTextForMoreLength;
};

const handleRepresentativeJobTitleChange = (event, dispatch, task, data) => {
  const updatedClientInformation = { ...task.documentsDashboard.clientInformation };
  updatedClientInformation.representativeJobTitle = event.target.value;

  updateClientInformation(dispatch, data, task, updatedClientInformation);
};

const handleRepresentativePhoneChange = (event, dispatch, task, data) => {
  const updatedClientInformation = { ...task.documentsDashboard.clientInformation };
  updatedClientInformation.representativePhone = event.target.value;

  updateClientInformation(dispatch, data, task, updatedClientInformation);
};

const updateClientInformation = (dispatch, data, task, clientInformation) => {
  const tasks = [...data.tasks];
  const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
  tasks.splice(taskIndex, 1, {
    ...task,
    documentsDashboard: { ...task.documentsDashboard, clientInformation: clientInformation },
  });

  dispatchData(dispatch, data, tasks);
};

export {
  handleStartChange,
  handleEndChange,
  handleTroubleDescriptionChange,
  handlePerformedActivitiesDescriptionChange,
  handleDamageDescriptionChange,
  handleClientNotAgreedDescriptionChange,
  toggleProtocolFields,
  toggleDamageDescriptionField,
  toggleAggreedWithPerformedActivitiesDescriptionField,
  validateDescriptiveProtocol,
  getMessageForField,
  handleRepresentativeJobTitleChange,
  handleRepresentativePhoneChange,
  updateClientInformation,
};
